import { motion } from 'framer-motion'
import { ReactNode } from 'react'

interface PresentationProps {
  children: ReactNode
  direction: number
}

const slideVariants = {
  enter: (direction: number) => ({
    x: direction > 0 ? '100%' : '-100%',
    opacity: 0,
    scale: 0.95,
  }),
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1,
    scale: 1,
  },
  exit: (direction: number) => ({
    zIndex: 0,
    x: direction < 0 ? '100%' : '-100%',
    opacity: 0,
    scale: 0.95,
  }),
}

const slideTransition = {
  x: { type: 'spring', stiffness: 300, damping: 30 },
  opacity: { duration: 0.4 },
  scale: { duration: 0.4 },
}

export default function Presentation({ children, direction }: PresentationProps) {
  return (
    <motion.div
      custom={direction}
      variants={slideVariants}
      initial="enter"
      animate="center"
      exit="exit"
      transition={slideTransition}
      className="absolute inset-0 flex items-center justify-center p-8 lg:p-16"
    >
      <div className="w-full max-w-7xl h-full">
        {children}
      </div>
    </motion.div>
  )
}
